(function () {
  if (typeof customElements === 'undefined' || customElements.get('sale-countdown')) return;

  const instances = new Set();
  let timerId = null;

  function startGlobalTimer() {
    if (timerId !== null) return;
    timerId = setInterval(() => {
      instances.forEach((el) => el.tick());
    }, 1000);
  }

  function stopGlobalTimer() {
    if (instances.size === 0 && timerId !== null) {
      clearInterval(timerId);
      timerId = null;
    }
  }

  class SaleCountdown extends HTMLElement {
    connectedCallback() {
      try {
        this.variants = JSON.parse(this.getAttribute('data-variants') || '[]');
      } catch (e) {
        this.variants = [];
      }

      this.context = this.getAttribute('data-context') || 'card';
      const cv = parseInt(this.getAttribute('data-current-variant'), 10);
      this.currentVariantId = Number.isNaN(cv) ? null : cv;

      this.elDays = this.querySelector('[data-days]');
      this.elHours = this.querySelector('[data-hours]');
      this.elMinutes = this.querySelector('[data-minutes]');
      this.elSeconds = this.querySelector('[data-seconds]');

      this.detectInitialVariant();
      this.bindVariantChange();
      this.bindCustomVariantPicker();

      instances.add(this);
      startGlobalTimer();
      this.refresh();
    }

    disconnectedCallback() {
      instances.delete(this);
      stopGlobalTimer();
      if (this._productVariantsEl && this._variantHandler) {
        this._productVariantsEl.removeEventListener('VARIANT_CHANGE', this._variantHandler);
      }
      if (this._pickerClickHandler) {
        document.removeEventListener('click', this._pickerClickHandler, true);
      }
    }

    detectInitialVariant() {
      if (this.context !== 'product-page') return;
      const activePick = document.querySelector('.m_prod_vars > div.active[data-varid]');
      if (activePick) {
        const id = parseInt(activePick.getAttribute('data-varid'), 10);
        if (!Number.isNaN(id)) this.currentVariantId = id;
      }
    }

    bindVariantChange() {
      if (this.context !== 'product-page') return;
      const sectionId = this.getAttribute('data-section-id');
      const selector = sectionId
        ? `product-variants[data-id="${sectionId}"]`
        : 'product-variants';
      const el = document.querySelector(selector);
      if (!el) return;
      this._productVariantsEl = el;
      this._variantHandler = () => {
        this.currentVariantId = el.currentVariant ? el.currentVariant.id : null;
        this.refresh();
      };
      el.addEventListener('VARIANT_CHANGE', this._variantHandler);
    }

    bindCustomVariantPicker() {
      if (this.context !== 'product-page') return;
      this._pickerClickHandler = (event) => {
        const target = event.target.closest('[data-varid]');
        if (!target) return;
        const id = parseInt(target.getAttribute('data-varid'), 10);
        if (Number.isNaN(id)) return;
        this.currentVariantId = id;
        this.refresh();
      };
      document.addEventListener('click', this._pickerClickHandler, true);
    }

    getActiveSale() {
      const now = Math.floor(Date.now() / 1000);

      if (this.context === 'product-page') {
        if (!this.currentVariantId) return null;
        const sale = this.variants.find((v) => v.id === this.currentVariantId);
        if (!sale) return null;
        if (sale.start <= now && now < sale.end) return sale;
        return null;
      }

      for (const v of this.variants) {
        if (v.start <= now && now < v.end) return v;
      }
      return null;
    }

    refresh() {
      const sale = this.getActiveSale();
      if (!sale) {
        this.style.display = 'none';
        this.activeEnd = null;
        return;
      }
      this.activeEnd = sale.end;
      this.style.display = '';
      this.render();
    }

    tick() {
      if (!this.activeEnd) {
        if (this.context === 'product-page' && !this.currentVariantId) return;
        this.refresh();
        return;
      }
      const now = Math.floor(Date.now() / 1000);
      if (now >= this.activeEnd) {
        this.refresh();
        return;
      }
      this.render();
    }

    render() {
      if (!this.activeEnd) return;
      const now = Math.floor(Date.now() / 1000);
      let diff = this.activeEnd - now;
      if (diff < 0) diff = 0;

      const days = Math.floor(diff / 86400);
      diff -= days * 86400;
      const hours = Math.floor(diff / 3600);
      diff -= hours * 3600;
      const minutes = Math.floor(diff / 60);
      const seconds = diff - minutes * 60;

      if (this.elDays) this.elDays.textContent = days;
      if (this.elHours) this.elHours.textContent = String(hours).padStart(2, '0');
      if (this.elMinutes) this.elMinutes.textContent = String(minutes).padStart(2, '0');
      if (this.elSeconds) this.elSeconds.textContent = String(seconds).padStart(2, '0');
    }
  }

  customElements.define('sale-countdown', SaleCountdown);
})();
